import AvailabilityDay from './AvailabilityDay';

export default function AvailabilityList({
  weekdays,
  recurring,
  openDays,
  checkboxAction,
}) {
  return (
    <>
      {weekdays
        .map((dow, i) => {
          const dayData = recurring.filter((el) => el.dow.value === dow)[0];
          return (
            <AvailabilityDay
              key={dow}
              day={dow}
              openDays={openDays}
              checkboxAction={checkboxAction}
              binAction={checkboxAction}
              dayData={dayData}
            />
          );
        })
        .filter(Boolean)}
    </>
  );
}
